import React from 'react';
import { Box, Container, Typography, Grid, Paper } from '@mui/material';
import { colors } from '../theme';

function PartnersSection() {
  const partners = [
    { name: 'Ark', logo: '/partners/ark-logo.png' },
    { name: 'RXS', logo: '/partners/rxs-logo.png' },
    { name: 'Siemens', logo: '/partners/siemens-logo.png' },
    { name: 'Solateks', logo: '/partners/solateks-logo.svg' },
    { name: 'Tsapa', logo: '/partners/tsapa-logo.png' },
    { name: 'StarCharge', logo: '/partners/starcharge-logo.jpg' },
  ];

  return (
    <Box
      id="partners"
      sx={{
        py: { xs: 6, md: 8 },
        bgcolor: '#f8f8f8',
      }}
    >
      <Container maxWidth="lg">
        {/* Section Header */}
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: '2rem', md: '2.75rem' },
              fontWeight: 800,
              mb: 2,
              color: colors.black,
            }}
          >
            Our{' '}
            <Box component="span" sx={{ color: colors.green }}>
              Partners
            </Box>
          </Typography>
          <Typography
            variant="h6"
            sx={{
              color: '#666',
              maxWidth: '700px',
              mx: 'auto',
              fontSize: { xs: '1rem', md: '1.2rem' },
            }}
          >
            Working with industry-leading brands to deliver excellence
          </Typography>
        </Box>

        {/* Partners Grid */}
        <Grid container spacing={3} justifyContent="center">
          {partners.map((partner, index) => (
            <Grid item xs={6} sm={4} md={4} key={index}>
              <Paper
                elevation={0}
                sx={{
                  p: 2.5,
                  height: 130,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: 3,
                  border: 'none',
                  transition: 'all 0.3s ease',
                  bgcolor: 'transparent',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                  },
                }}
              >
                <Box
                  component="img"
                  src={partner.logo}
                  alt={partner.name}
                  sx={{
                    maxWidth: '100%',
                    maxHeight: 60,
                    objectFit: 'contain',
                    mb: 1.5,
                  }}
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
                <Box
                  sx={{
                    display: 'none',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 700,
                      fontSize: '1.1rem',
                      color: colors.black,
                    }}
                  >
                    {partner.name}
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>

        {/* Trust Statement */}
        <Box
          sx={{
            mt: 6,
            p: 3,
            borderRadius: 4,
            background: `linear-gradient(135deg, ${colors.green}15 0%, ${colors.yellow}15 100%)`,
            textAlign: 'center',
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              color: colors.black,
              mb: 0.5,
              fontSize: { xs: '1.2rem', md: '1.4rem' },
            }}
          >
            Trusted by Leading Organizations
          </Typography>
          <Typography
            sx={{
              color: '#666',
              fontSize: '0.95rem',
              maxWidth: '600px',
              mx: 'auto',
            }}
          >
            We collaborate with world-class brands to bring you reliable,
            cutting-edge EV charging and energy solutions
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default PartnersSection;
